import React, { Component } from 'react';

// Expecting responses in the form
// {
//   success:  true/false,
//   data:     {},
//   messages: {
//     notices: [''],
//     errors:  [''],
//     alerts:  ['']
//   }
// }

function serviceInterface(ServiceComponent, options) {
  class ServiceInterfaceClient extends Component {
    constructor(props) {
      super(props);
      this.state = {
        success: undefined,
        data: {},
        messages: { errors:  [],
                    notices: [],
                    alerts:  [] }
      };
      this.parseResponse = this.parseResponse.bind(this)
    }

    parseResponse(response) {
      const { messages, data, success } = response;
      this.setState({ messages, data, success });
    }

    render() {
      const { messages, data, success } = this.state
      return (<ServiceComponent messages={messages}
                                response_data={data || {}}
                                success={success}
                                parseResponse={this.parseResponse} {...this.props} />)
    }
  }
  return ServiceInterfaceClient;
}

export default serviceInterface;
